import React, { useEffect, useState } from 'react';
import { Row, Col, Avatar, Card, Button, Input, Select, DatePicker, message } from 'antd';
// import format from 'date-fns/format';
import { Link, useNavigate } from 'react-router-dom';
import '../../css/custom.css';
import Profile from '../../Images/Prof.png';
import Tag from '../../Images/Tag.png';
import noProfile from '../../Images/noProfile.png';
import { useAuth } from '../../Context';
import { BodyTextHeading, BodyTextKey, ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import moment from 'moment';
import CustomSpin from '../CommonSpin';
import { Content } from 'antd/es/layout/layout';
import { useDispatch, useSelector } from 'react-redux';
import { profileChangeRequest } from './Actions';
import { selectLoading, selectSuccessMsg } from './Selectors';

const EditProfile = () => {

    const {profileGet, patientDeatils, getCountry, countryList} = useAuth();
    const dateFormat = 'YYYY/MM/DD';

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const successMsg = useSelector(selectSuccessMsg);


    if(successMsg) {
        navigate('/profilefront');
    }
    
    const profiles = patientDeatils && patientDeatils ? patientDeatils[0] : null;
    const requesting = useSelector(selectLoading);
    
    useEffect(() => {
        profileGet();
        getCountry();
    }, []);
    
    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;    
    
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
    const [fileUpload, setFileUpload] = useState(null);
    const [firstName, setFirstName] = useState(profiles && profiles.firstName);
    const [lastName, setLastName] = useState(profiles && profiles.lastName);
    const [initials, setInitials] = useState(profiles && profiles.initials);
    const [gender, setGender] = useState(profiles && profiles.gender);
    const [bloodGroup, setBloodGroup] = useState(profiles && profiles.bloodGroup);
    const [dob, setDob] = useState(profiles && profiles.dob);
    const [altNumber, setAltNumber] = useState(profiles && profiles.secondaryContact);
    const [address, setAddress] = useState(profiles && profiles.address);
    const [residence, setResidence] = useState(profiles && profiles.residentCountry);

    const [firstNameFlag, setFirstNameFlag] = useState(false);
    const [lastNameFlag, setLastNameFlag] = useState(false);
    const [initialsFlag, setInitialsFlag] = useState(false);
    const [genderFlag, setGenderFlag] = useState(false);
    const [dobFlag, setDobFlag] = useState(false);
    const [isPrimaryDetailsUpdated, setIsPrimaryDetailsUpdated] = useState(false);
    
    const handleImageChange = (event) => {

        const reader = new FileReader();
        const file = event.target.files[0];
        if (file !== null) {
            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                reader.onloadend = () => {
                    setImagePreviewUrl(reader.result);
                    setFileUpload(file);
                };
            }
            reader.readAsDataURL(file);
        } else {
        message.error('File is not chosen'); // eslint-disable-line
        }
    };

    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current > moment().endOf('day');
    };

    const handleDateOfBirthChange = (value, date) => {
        if(dobFlag == false ){
            message.config({
                duration : 5,
                maxCount : 1,
            });
            message.warning({
                type: 'warning',
                content: `${langdata.Yourprofilechangeswillbesendtoadminforverification ? langdata.Yourprofilechangeswillbesendtoadminforverification : 'Your profile changes will be send to admin for verification.' }`,
            });
            setDobFlag(true);
        }
        setDob(date);        
        setIsPrimaryDetailsUpdated(true);
    };

    const handleFirstName = (e) => {
        if(firstNameFlag == false ){
            message.config({
                duration : 5,
                maxCount : 1,
            });
            message.warning({
                type: 'warning',
                content: `${langdata.Yourprofilechangeswillbesendtoadminforverification ? langdata.Yourprofilechangeswillbesendtoadminforverification : 'Your profile changes will be send to admin for verification.' }`,
            });
            setFirstNameFlag(true);
        }
        setFirstName(e.target.value);
        setIsPrimaryDetailsUpdated(true);
    };

    const handleLastName = (e) => {
        if(lastNameFlag == false ){
            message.config({
                duration : 5,
                maxCount : 1,
            });
            message.warning({
                type: 'warning',
                content: `${langdata.Yourprofilechangeswillbesendtoadminforverification ? langdata.Yourprofilechangeswillbesendtoadminforverification : 'Your profile changes will be send to admin for verification.' }`,
            });
            setLastNameFlag(true);
        }
        setLastName(e.target.value);
        setIsPrimaryDetailsUpdated(true);
    };

    const handleInitals = (value) => {
        if(initialsFlag == false ){
            message.config({
                duration : 5,
                maxCount : 1,
            });
            message.warning({
                type: 'warning',
                content: `${langdata.Yourprofilechangeswillbesendtoadminforverification ? langdata.Yourprofilechangeswillbesendtoadminforverification : 'Your profile changes will be send to admin for verification.' }`,
            });
            setInitialsFlag(true);
        }
        setInitials(value);
        setIsPrimaryDetailsUpdated(true);
    };

    const handleGender = (value) => {
        if(genderFlag == false ){
            message.config({
                duration : 5,
                maxCount : 1,
            });
            message.warning({
                type: 'warning',
                content: `${langdata.Yourprofilechangeswillbesendtoadminforverification ? langdata.Yourprofilechangeswillbesendtoadminforverification : 'Your profile changes will be send to admin for verification.' }`,
            });
            setGenderFlag(true);
        }
        setGender(value);
        setIsPrimaryDetailsUpdated(true);
    };
        
    const countryListing = [];
    if (countryList) {
        countryList && countryList.map((item) => {
            countryListing.push({
                value : item.name,
                label : item.name
            });
        });
    }    

    const handleSubmit = () => {

        const payload = {
            id : profiles && profiles.id,
            firstName : firstName ? firstName : profiles && profiles.firstName,
            lastName : lastName ? lastName : profiles && profiles.lastName,
            initials : initials ? initials :  profiles && profiles.initials,
            gender : gender ? gender :  profiles && profiles.gender,
            bloodGroup : bloodGroup ? bloodGroup : profiles && profiles.bloodGroup,
            dob : dob ? dob : profiles && profiles.dob,
            altNumber : altNumber ? altNumber : profiles && profiles.secondaryContact,
            address : address ? address : profiles && profiles.address,
            residence : residence ? residence : profiles && profiles.residentCountry,
            isPrimaryDetailsUpdated : isPrimaryDetailsUpdated,
            image : fileUpload ? fileUpload : null
        };
        dispatch(profileChangeRequest(payload));
    };

    let profBody;
    if (profiles !== null) {
        profBody = (
            <div key={profiles.id}>
                <Row type="flex" justify="center">
                    <Col xs={{ span: 24 }} sm={{span:24}} md={{ span: 22 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
                        {/* Upper Header contains profile photo, name, edit button */}
                        <Row>
                            <Col xs={{ span: 24 }} sm={{span:24}} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }} style={{ minHeight: '180px', background: '#1164A6' }}>
                                <Row>
                                    <Col
                                        xs={{ span: 24 }}
                                        sm={{span: 8}}
                                        md={{ span: 5 }}
                                        lg={{ span: 4 }}
                                        xl={{ span: 4 }}
                                        xxl={{ span: 4 }}
                                        style={{ paddingTop: '10px', paddingBottom: '10px' }}
                                    >
                                        <Col span={24} style={{display:'flex', justifyContent:'center'}}>
                                            <Avatar
                                                style={{ width: '120px', height: '120px' }}
                                                src={
                                                    imagePreviewUrl !== null
                                                        ? imagePreviewUrl
                                                        : profiles.profilephotourl === null
                                                            ? noProfile
                                                            : profiles.profilephotourl
                                                }
                                            />
                                        </Col>
                                        <Col span={24} style={{marginTop:'3px', display:'flex', justifyContent:'center'}}>
                                            <Button
                                                type="primary"
                                                style={{
                                                    width: '120px',
                                                    textAlign: 'center',
                                                    backgroundColor: '#1164A6',
                                                    borderColor: '#ffffff',
                                                    borderRadius: '8px',
                                                    // display : 'flow',
                                                    justifyContent: 'center',
                                                    cursor : 'pointer'
                                                }}
                                                // title="Change Photo"
                                            >
                                                <ButtonText text = {`${langdata.ChangePhoto ? langdata.ChangePhoto : 'Change Photo' }`} />
                                                {/* Change Photo */}
                                                <input
                                                    style={{
                                                        opacity: '0',
                                                        width: '120px',
                                                        marginLeft: '-125px',
                                                        textAlign: 'center',
                                                        cursor : 'pointer',
                                                        display : 'flex'
                                                    }}
                                                    type="file"
                                                    id="myuniqueid"
                                                    onChange={handleImageChange}
                                                />
                                            </Button>
                                        </Col>
                                    </Col>
                                    <Col
                                        xs={{ span: 24, offset: 0 }}
                                        sm={{span: 16, offset: 0}}
                                        md={{ span: 19, offset: 0 }}
                                        lg={{ span: 12, offset: 0 }}
                                        xl={{ span: 12, offset: 0 }}
                                        xxl={{ span: 12, offset: 0 }}
                                        style={{
                                            marginTop: '70px',
                                            // fontWeight: '100',
                                            fontSize: '22px',
                                            color: '#FFFFFF',
                                            // fontFamily: 'Roboto',
                                            // marginLeft:'10px'
                                        }}
                                    >
                                        <Col span={24} style={{display:'flex', justifyContent:'center'}}>
                                            <Input
                                                value={firstName ? firstName : profiles && profiles.firstName}
                                                onChange={handleFirstName}     
                                                style={{ width: '30%' }}
                                                placeholder={'First Name'}
                                            />
                                            <Input
                                                value={lastName ? lastName : profiles && profiles.lastName}
                                                onChange={handleLastName}     
                                                style={{ width: '30%', marginLeft: '10px' }}
                                                placeholder={'Last Name'}
                                            />
                                        </Col>
                                    </Col>
                                    <Col 
                                        xs={{ span: 24, offset: 0 }}
                                        sm={{ span: 24, offset: 0 }}
                                        md={{ span: 0, offset: 0 }}
                                        lg={{ span: 0, offset: 0 }}
                                        xl={{ span: 0, offset: 0 }}
                                        xxl={{ span: 4, offset: 0 }}
                                    >&nbsp;</Col>
                                    <Col 
                                        xs={{ span: 24, offset: 0 }}
                                        sm={{ span: 24, offset: 0 }}
                                        md={{ span: 24, offset: 0 }}
                                        lg={{ span: 8, offset: 0 }}
                                        xl={{ span: 8, offset: 0 }}
                                        xxl={{ span: 4, offset: 0 }}
                                        style={{ marginTop: '80px', textAlign: 'right', marginBottom:'10px' }}>
                                        <Col span={24} style={{display:'flex', justifyContent:'center'}}>
                                            <Link to="/profilefront">
                                                <Button
                                                    style={{
                                                        width: '90px',
                                                        backgroundColor: '#1164A6',
                                                        borderColor: '#ffffff',
                                                        borderRadius: '8px',
                                                        color: '#ffffff',
                                                    }}
                                                >
                                                    <ButtonText text = {`${langdata.Cancel ? langdata.Cancel : 'Cancel' }`} />
                                                </Button>{' '}
                                            </Link>
                                            <Button
                                                onClick={handleSubmit}
                                                style={{
                                                    width: '90px',
                                                    backgroundColor: '#1164A6',
                                                    borderColor: '#ffffff',
                                                    borderRadius: '8px',
                                                    marginLeft: '10px',
                                                }}
                                                type="primary"
                                            >
                                                <ButtonText text = {`${langdata.Save ? langdata.Save : 'Save' }`} />
                                            </Button>
                                        </Col>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        {/* Body Personal info */}
                        <Row>
                            <Col
                                xs={{ span: 24 }}
                                md={{ span: 22 }}
                                lg={{ span: 22 }}
                                xl={{ span: 24 }}
                                xxl={{ span: 24 }}
                            >
                                <Row>
                                    <Col
                                        xs={{ span: 22, offset: 1 }}
                                        md={{ span: 22, offset: 1 }}
                                        lg={{ span: 10, offset: 1 }}
                                        xl={{ span: 10, offset: 1 }}
                                        xxl={{ span: 10, offset: 1 }}
                                    >
                                        <Card
                                            style={{
                                                marginBottom: '10px',
                                                width: '100%',
                                                marginTop: '20px',
                                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.18)',
                                                borderRadius: '8px',
                                                paddingBottom: '20px',
                                            }}
                                        >
                                            {/* <Row> */}
                                            <Col>
                                                <div style={{ float: 'left' }}>
                                                    <Avatar
                                                        shape="square"
                                                        src={Profile}
                                                        style={{ width: '31px', height: '33px' }}
                                                    />
                                                </div>
                                                <div style={{ fontSize: '21px', marginLeft: '6%', color: '#000000' }}>
                                                    <BodyTextHeading text={`${langdata.PersonalInfo ? langdata.PersonalInfo : 'Personal Info' }`} />
                                                </div>
                                            </Col>
                                            {/* </Row> */}
                                            <Row style={{ marginTop: '12px' }}>
                                                <Col span={24}>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={6} style={{
                                                                display : 'flex',
                                                                // justifyContent : 'flex-end'
                                                            }}>
                                                                <BodyTextKey text='Initials'/>                                                          
                                                            </Col>
                                                            <Col span={13} style={{
                                                                display : 'flex',
                                                                justifyContent : 'flex-start'
                                                            }}>
                                                                {/* :&nbsp;&nbsp;&nbsp; */}
                                                                <Select
                                                                    placeholder="Please select Initials"
                                                                    value={initials ? initials : profiles && profiles.initials}
                                                                    // onChange={(value) => {setInitials(value);}}
                                                                    onChange={handleInitals}
                                                                    style={{ width: '100%' }}
                                                                >
                                                                    <Select.Option value={'Mr.'}>Mr.</Select.Option>
                                                                    <Select.Option value={'Mrs.'}>Mrs.</Select.Option>
                                                                    <Select.Option value={'Miss.'}>Miss.</Select.Option>
                                                                    <Select.Option value={'Ms.'}>Ms.</Select.Option>
                                                                    <Select.Option value={'Master.'}>Master.</Select.Option>
                                                                </Select>                                                            
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={6} style={{
                                                                display : 'flex',
                                                                // justifyContent : 'flex-end'
                                                            }}>
                                                                <BodyTextKey text={`${langdata.Gender ? langdata.Gender : 'Gender' }`}/>
                                                            </Col>
                                                            <Col span={13} style={{
                                                                display : 'flex',
                                                                justifyContent : 'flex-start'
                                                            }}>
                                                                {/* &nbsp;:&nbsp; */}
                                                                <Select
                                                                    placeholder="Please select gender"
                                                                    value={gender ? gender : profiles && profiles.gender}
                                                                    onChange={handleGender}
                                                                    style={{ width: '100%' }}
                                                                >
                                                                    <Select.Option value={'Female'}>Female</Select.Option>
                                                                    <Select.Option value={'Male'}>Male</Select.Option>
                                                                    <Select.Option value={'Others'}>Others</Select.Option>

                                                                </Select>                                                      
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={6} style={{
                                                                display : 'flex',
                                                                // justifyContent : 'flex-end'
                                                            }}>
                                                                <BodyTextKey text={`${langdata.BloodGroup ? langdata.BloodGroup : 'Blood Group' }`}/>
                                                            </Col>
                                                            <Col span={13} style={{
                                                                display : 'flex',
                                                                justifyContent : 'flex-start'
                                                            }}>
                                                                {/* &nbsp;:&nbsp; */}
                                                                <Select
                                                                    placeholder="Please select Blood Group"
                                                                    onChange={(value) => {
                                                                        setBloodGroup(value);
                                                                    }}
                                                                    style={{ width: '100%' }}
                                                                    value={bloodGroup ? bloodGroup : profiles && profiles.bloodGroup}
                                                                >
                                                                    <Select.Option value={'A+'}>A+</Select.Option>
                                                                    <Select.Option value={'A-'}>A-</Select.Option>
                                                                    <Select.Option value={'B+'}>B+</Select.Option>
                                                                    <Select.Option value={'B-'}>B-</Select.Option>
                                                                    <Select.Option value={'O+'}>O+</Select.Option>
                                                                    <Select.Option value={'O-'}>O-</Select.Option>
                                                                    <Select.Option value={'AB+'}>AB+</Select.Option>
                                                                    <Select.Option value={'AB-'}>AB-</Select.Option>
                                                                    <Select.Option value={'Not Specified'}>Not Specified</Select.Option>
                                                                </Select>                                                  
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={6} style={{
                                                                display : 'flex',
                                                                // justifyContent : 'flex-end'
                                                            }}>
                                                                <BodyTextKey text={`${langdata.DateofBirth ? langdata.DateofBirth : 'Date of Birth' }`}/>
                                                            </Col>
                                                            <Col span={13} style={{
                                                                display : 'flex',
                                                                justifyContent : 'flex-start'
                                                            }}>
                                                                {/* &nbsp;:&nbsp; */}
                                                                <DatePicker
                                                                    onChange={handleDateOfBirthChange}
                                                                    style={{ width: '100%' }}
                                                                    defaultValue={(dob ? dob : profiles && profiles.dob) ? moment((dob ? dob : profiles && profiles.dob), dateFormat) : null}
                                                                    format={'DD/MM/YYYY'}
                                                                    disabledDate={disabledDate}
                                                                />                                               
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                    <Col
                                        xs={{ span: 22, offset: 1 }}
                                        md={{ span: 22, offset: 1 }}
                                        lg={{ span: 11, offset: 1 }}
                                        xl={{ span: 11, offset: 1 }}
                                        xxl={{ span: 11, offset: 1 }}
                                    >
                                        <Card
                                            style={{
                                                width: '100%',
                                                marginTop: '20px',
                                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.18)',
                                                borderRadius: '8px',
                                                marginBottom: '10px',
                                                paddingBottom: '20px',
                                            }}
                                        >
                                            {/* <Row> */}
                                            <Col>
                                                <div style={{ float: 'left' }}>
                                                    <Avatar
                                                        shape="square"
                                                        src={Tag}
                                                        style={{ width: '20px', height: '30px', marginTop: '10%' }}
                                                    />
                                                </div>
                                                <div style={{ fontSize: '21px', marginLeft: '4%', color: '#000000' }}>
                                                    <BodyTextHeading text={`${langdata.Contact ? langdata.Contact : 'Contact'}`} />
                                                </div>
                                            </Col>
                                            {/* </Row> */}
                                            <Row style={{ marginTop: '12px' }}>
                                                <Col span={24}>
                                                    
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={6} style={{
                                                                display : 'flex',
                                                                // justifyContent : 'flex-end'
                                                            }}>
                                                                <BodyTextKey text={`${langdata.PhoneNumber ? langdata.PhoneNumber : 'Phone Number' }`}/>
                                                            </Col>
                                                            <Col span={13} style={{
                                                                display : 'flex',
                                                                justifyContent : 'flex-start'
                                                            }}>
                                                                {/* &nbsp;:&nbsp; */}
                                                                <Input
                                                                    placeholder="Please Enter Your Phone"
                                                                    value={profiles.primaryContact}
                                                                    // onChange={this.handleContactChange}
                                                                    style={{ width: '100%' }}
                                                                    disabled
                                                                />                                          
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={6} style={{
                                                                display : 'flex',
                                                                // justifyContent : 'flex-end'
                                                            }}>
                                                                <BodyTextKey text={`${langdata.AlternatePhoneNumber ? langdata.AlternatePhoneNumber : 'Alternate Phone Number' }`}/>
                                                            </Col>
                                                            <Col span={13} style={{
                                                                display : 'flex',
                                                                justifyContent : 'flex-start'
                                                            }}>
                                                                {/* &nbsp;:&nbsp; */}
                                                                <Input
                                                                    placeholder="Please Enter Your Alternate Phone Number"
                                                                    value={altNumber ? altNumber : profiles && profiles.secondaryContact}
                                                                    onChange={(e) => {
                                                                        setAltNumber(e.target.value);
                                                                    }}
                                                                    style={{ width: '100%' }}
                                                                />                                    
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={6} style={{
                                                                display : 'flex',
                                                                // justifyContent : 'flex-end'
                                                            }}>
                                                                <BodyTextKey text={`${langdata.Address ? langdata.Address : 'Address' }`}/>
                                                            </Col>
                                                            <Col span={13} style={{
                                                                display : 'flex',
                                                                justifyContent : 'flex-start'
                                                            }}>
                                                                {/* &nbsp;:&nbsp; */}
                                                                <Input
                                                                    placeholder="Please Enter Your Address"
                                                                    value={address ? address : profiles && profiles.address}
                                                                    onChange={(e) => {
                                                                        setAddress(e.target.value);
                                                                    }}
                                                                    style={{ width: '100%' }}
                                                                />                                
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={6} style={{
                                                                display : 'flex',
                                                                // justifyContent : 'flex-end'
                                                            }}>
                                                                <BodyTextKey text={`${langdata.Countryofresidence ? langdata.Countryofresidence : 'Country of residence' }`}/>
                                                            </Col>
                                                            <Col span={13} style={{
                                                                display : 'flex',
                                                                justifyContent : 'flex-start'
                                                            }}>
                                                                {/* &nbsp;:&nbsp; */}
                                                                <Select
                                                                    showSearch
                                                                    onChange={(value) => {
                                                                        setResidence(value);
                                                                    }}
                                                                    value={residence ? residence : profiles && profiles.residentCountry}
                                                                    placeholder="Please select a country"
                                                                    optionFilterProp="children"
                                                                    style={{ width: '100%' }}
                                                                    options={countryListing}
                                                                    filterOption={(input, option) =>
                                                                        option.props.children
                                                                            .toLowerCase()
                                                                            .indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                >
                                                                    {/* {countryListing} */}
                                                                </Select>                           
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <Content>
            <div>{profBody}</div>
            <CustomSpin spinning = {requesting} />

        </Content>
    );
};

export default EditProfile;
